const preciseLevel = 2;

export default function (value) {
    try {
        return value.toFixed(preciseLevel).replace('.', ',');
    } catch (e) {
        return value;
    }
}
